<div class="stats-appointments">
  <!-- KPI Summary -->
  <section class="stats-appointments__kpis">
    <app-kpi-card
      [title]="'STATISTICS.APPOINTMENTS.KPIS.TOTAL' | translate"
      [value]="metrics?.totalAppointments || 0"
      [previousValue]="metrics?.totalAppointmentsKpi?.previousValue || null"
      [trend]="metrics?.totalAppointmentsKpi?.trend || null"
      format="number"
      icon="pi-calendar"
      iconColor="primary"
      [loading]="loadingMetrics"
    />
    <app-kpi-card
      [title]="'STATISTICS.APPOINTMENTS.KPIS.COMPLETED' | translate"
      [value]="metrics?.completedAppointments || 0"
      [previousValue]="metrics?.completedAppointmentsKpi?.previousValue || null"
      [trend]="metrics?.completedAppointmentsKpi?.trend || null"
      format="number"
      icon="pi-check-circle"
      iconColor="success"
      [loading]="loadingMetrics"
    />
    <app-kpi-card
      [title]="'STATISTICS.APPOINTMENTS.KPIS.OCCUPANCY_RATE' | translate"
      [value]="metrics?.occupancyRate || 0"
      [previousValue]="metrics?.occupancyRateKpi?.previousValue || null"
      [trend]="metrics?.occupancyRateKpi?.trend || null"
      format="percent"
      icon="pi-clock"
      iconColor="info"
      [loading]="loadingMetrics"
      [upIsGood]="true"
    />
    <app-kpi-card
      [title]="'STATISTICS.APPOINTMENTS.KPIS.NO_SHOW' | translate"
      [value]="metrics?.noShowRate || 0"
      [previousValue]="metrics?.noShowRateKpi?.previousValue || null"
      [trend]="metrics?.noShowRateKpi?.trend || null"
      format="percent"
      icon="pi-times-circle"
      iconColor="danger"
      [loading]="loadingMetrics"
      [upIsGood]="false"
    />
    <app-kpi-card
      [title]="'STATISTICS.APPOINTMENTS.KPIS.CANCELLATIONS' | translate"
      [value]="metrics?.cancellationRate || 0"
      [previousValue]="metrics?.cancellationRateKpi?.previousValue || null"
      [trend]="metrics?.cancellationRateKpi?.trend || null"
      format="percent"
      icon="pi-ban"
      iconColor="warning"
      [loading]="loadingMetrics"
      [upIsGood]="false"
      [compact]="true"
    />
    <app-kpi-card
      [title]="'STATISTICS.APPOINTMENTS.KPIS.AVG_DURATION' | translate"
      [value]="metrics?.avgDuration || 0"
      [previousValue]="metrics?.avgDurationKpi?.previousValue || null"
      [trend]="metrics?.avgDurationKpi?.trend || null"
      format="number"
      icon="pi-stopwatch"
      iconColor="primary"
      [loading]="loadingMetrics"
      [compact]="true"
      suffix="min"
    />
  </section>

  <!-- Heatmap -->
  <section class="stats-appointments__heatmap-section">
    <div class="stats-appointments__card">
      <div class="stats-appointments__card-header">
        <h2>
          <i class="pi pi-th-large"></i>
          {{ "STATISTICS.APPOINTMENTS.HEATMAP.TITLE" | translate }}
        </h2>
        <span class="stats-appointments__subtitle">{{
          "STATISTICS.APPOINTMENTS.HEATMAP.SUBTITLE" | translate
        }}</span>
      </div>
      <div
        class="stats-appointments__card-body stats-appointments__card-body--no-padding"
      >
        @if (loadingHeatmap) {
          <div class="stats-appointments__heatmap-placeholder">
            {{ "STATISTICS.APPOINTMENTS.HEATMAP.LOADING" | translate }}
          </div>
        } @else if (heatmapData.length === 0) {
          <div class="stats-appointments__heatmap-placeholder">
            {{ "STATISTICS.APPOINTMENTS.HEATMAP.EMPTY" | translate }}
          </div>
        } @else {
          <div class="stats-appointments__heatmap">
            <table>
              <thead>
                <tr>
                  <th></th>
                  @for (hour of heatmapHours; track hour) {
                    <th>{{ hour }}</th>
                  }
                </tr>
              </thead>
              <tbody>
                @for (day of heatmapDays; track day; let i = $index) {
                  <tr>
                    <td class="day-label">{{ day }}</td>
                    @for (value of heatmapData[i]; track $index) {
                      <td>
                        <span
                          class="heatmap-cell"
                          [ngClass]="getHeatmapCellClass(value)"
                        >
                          {{ value }}
                        </span>
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
            <div class="stats-appointments__heatmap-legend">
              <span>{{ "STATISTICS.APPOINTMENTS.HEATMAP.LESS" | translate }}</span>
              <span class="legend-cell legend-cell--none"></span>
              <span class="legend-cell legend-cell--low"></span>
              <span class="legend-cell legend-cell--medium"></span>
              <span class="legend-cell legend-cell--high"></span>
              <span class="legend-cell legend-cell--very-high"></span>
              <span>{{ "STATISTICS.APPOINTMENTS.HEATMAP.MORE" | translate }}</span>
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- Charts Row -->
  <section class="stats-appointments__charts">
    <!-- Hourly Distribution -->
    <div class="stats-appointments__card">
      <div class="stats-appointments__card-header">
        <h2>
          <i class="pi pi-clock"></i>
          {{ "STATISTICS.APPOINTMENTS.CHARTS.HOURLY" | translate }}
        </h2>
      </div>
      <div class="stats-appointments__card-body">
        <app-stat-chart
          type="bar"
          [data]="hourlyChartData"
          [options]="hourlyChartOptions"
          [loading]="loadingHourly"
          [empty]="hourlyData.length === 0"
          height="350px"
        />
      </div>
    </div>

    <!-- Daily Distribution -->
    <div class="stats-appointments__card">
      <div class="stats-appointments__card-header">
        <h2>
          <i class="pi pi-calendar-times"></i>
          {{ "STATISTICS.APPOINTMENTS.CHARTS.DAILY" | translate }}
        </h2>
      </div>
      <div class="stats-appointments__card-body">
        <app-stat-chart
          type="bar"
          [data]="dailyChartData"
          [options]="dailyChartOptions"
          [loading]="loadingDaily"
          [empty]="dailyData.length === 0"
          height="350px"
        />
      </div>
    </div>
  </section>

  <!-- Status + Insights -->
  <section class="stats-appointments__bottom-row">
    <!-- Status Distribution -->
    <div class="stats-appointments__card">
      <div class="stats-appointments__card-header">
        <h2>
          <i class="pi pi-chart-bar"></i>
          {{ "STATISTICS.APPOINTMENTS.CHARTS.STATUS" | translate }}
        </h2>
      </div>
      <div
        class="stats-appointments__card-body stats-appointments__card-body--centered"
      >
        <app-stat-chart
          type="bar"
          [data]="statusChartData"
          [options]="statusChartOptions"
          [loading]="loadingStatus"
          height="220px"
        />
      </div>
    </div>

    <!-- Insights -->
    <div class="stats-appointments__card stats-appointments__card--insights">
      <div class="stats-appointments__card-header">
        <h2>
          <i class="pi pi-lightbulb"></i>
          {{ "STATISTICS.APPOINTMENTS.INSIGHTS.TITLE" | translate }}
        </h2>
      </div>
      <div class="stats-appointments__card-body">
        <ul class="stats-appointments__insights">
          @if (metrics && metrics.noShowRate > 10) {
            <li class="insight insight--warning">
              <i class="pi pi-exclamation-triangle"></i>
              <div>
                <strong>{{
                  "STATISTICS.APPOINTMENTS.INSIGHTS.HIGH_NO_SHOW.TITLE"
                    | translate: { rate: (metrics.noShowRate | number: "1.1-1") }
                }}</strong>
                <p>
                  {{
                    "STATISTICS.APPOINTMENTS.INSIGHTS.HIGH_NO_SHOW.DESCRIPTION"
                      | translate
                  }}
                </p>
              </div>
            </li>
          }
          @if (metrics && metrics.occupancyRate < 70) {
            <li class="insight insight--info">
              <i class="pi pi-info-circle"></i>
              <div>
                <strong>{{
                  "STATISTICS.APPOINTMENTS.INSIGHTS.AVAILABLE_CAPACITY.TITLE"
                    | translate
                }}</strong>
                <p>
                  {{
                    "STATISTICS.APPOINTMENTS.INSIGHTS.AVAILABLE_CAPACITY.DESCRIPTION"
                      | translate
                        : { free: (100 - metrics.occupancyRate | number: "1.0-0") }
                  }}
                </p>
              </div>
            </li>
          }
          @if (metrics && metrics.avgDuration > 0) {
            <li class="insight insight--success">
              <i class="pi pi-check-circle"></i>
              <div>
                <strong>{{
                  "STATISTICS.APPOINTMENTS.INSIGHTS.OPTIMAL_DURATION.TITLE"
                    | translate
                }}</strong>
                <p>
                  {{
                    "STATISTICS.APPOINTMENTS.INSIGHTS.OPTIMAL_DURATION.DESCRIPTION"
                      | translate: { minutes: metrics.avgDuration }
                  }}
                </p>
              </div>
            </li>
          }
          @if (!loadingHourly && hourlyData.length > 0) {
            <li class="insight insight--primary">
              <i class="pi pi-chart-line"></i>
              <div>
                <strong>{{
                  "STATISTICS.APPOINTMENTS.INSIGHTS.PEAK_HOUR.TITLE" | translate
                }}</strong>
                <p>
                  {{
                    "STATISTICS.APPOINTMENTS.INSIGHTS.PEAK_HOUR.DESCRIPTION"
                      | translate: { hour: getPeakHourLabel() }
                  }}
                </p>
              </div>
            </li>
          }
          @if (!loadingDaily && dailyData.length > 0) {
            <li class="insight insight--info">
              <i class="pi pi-calendar-plus"></i>
              <div>
                <strong>{{
                  "STATISTICS.APPOINTMENTS.INSIGHTS.BUSIEST_DAY.TITLE" | translate
                }}</strong>
                <p>
                  {{
                    "STATISTICS.APPOINTMENTS.INSIGHTS.BUSIEST_DAY.DESCRIPTION"
                      | translate: { day: getBusiestDayLabel() }
                  }}
                </p>
              </div>
            </li>
          }
          @if (!loadingHeatmap && heatmapData.length > 0) {
            <li class="insight insight--success">
              <i class="pi pi-th-large"></i>
              <div>
                <strong>{{
                  "STATISTICS.APPOINTMENTS.INSIGHTS.PEAK_SLOT.TITLE" | translate
                }}</strong>
                <p>
                  {{
                    "STATISTICS.APPOINTMENTS.INSIGHTS.PEAK_SLOT.DESCRIPTION"
                      | translate: { slot: getHeatmapPeakLabel() }
                  }}
                </p>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </section>
</div>
